export default __webpack_public_path__ + "static/14-853afa3c59224ad5a9e5724d3256871c.jpg";